import { Button, Result } from "antd";
import { useTranslation } from "react-i18next";

import useSmartNavigate from "hooks/useSmartNavigate";

const _404 = () => {
  const { t } = useTranslation();
  const { navigate } = useSmartNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle={t('common.noSuchPage')}
      extra={<Button type="primary" onClick={() => navigate("/")}>{t('common.goToHomePage')}</Button>}
    />
  );
};

export default _404;
